import React, { useEffect } from 'react';
import { Form, Select } from 'antd';
import { observer } from 'mobx-react-lite';
import QuickTurnBoltStore from 'stores/QuickTurnBoltStore';
import { QuickTurnBoltHeadType } from '@partsbadger/types';

function handleChange(value: string) {
    QuickTurnBoltStore.updateBoltById(QuickTurnBoltStore.boltToken, { bolt_head_type: value });
}

const BoltHeadSelector = () => {
    const { bolt_head_type } = QuickTurnBoltStore;

    const boltHeadTypes = QuickTurnBoltStore.boltHeadTypes.map((x: QuickTurnBoltHeadType) => {
        return {
            label: x?.display_name,
            value: x?.id,
        };
    });

    return (
        <Form.Item label="Head Type" className="mb-0">
            <Select
                options={boltHeadTypes}
                value={bolt_head_type}
                onChange={(value: string) => {
                    QuickTurnBoltStore.setBoltHeadType(value);
                    handleChange(value);
                }}
            />
        </Form.Item>
    );
};

export default observer(BoltHeadSelector);
